import React from "react";
import { User, LogOut } from "lucide-react";
import msgIcon from "../../images/msgIcon.png";
import styles from "./IphoneStyleIconMenu.module.css";

export default function IphoneStyleIconMenu({
  onProfileClick,
  onMessengerClick,
  onLogoutClick,
}) {
  const items = [
    {
      label: "ЛК",
      icon: User,
      type: "lucide",
      onClick: onProfileClick,
    },
    {
      label: "Мессенджер",
      icon: msgIcon,
      type: "image",
      onClick: onMessengerClick,
    },
    {
      label: "Выйти",
      icon: LogOut,
      type: "lucide",
      onClick: onLogoutClick,
    },
  ];

  return (
    <div className={styles.wrapper}>
      <div className={styles.grid}>
        {items.map((item) => (
          <button
            key={item.label}
            type="button"
            className={styles.item}
            onClick={item.onClick}
          >
            <div
              className={`${styles.iconBox} ${item.type === "image" ? styles.iconBoxImage : ""
                }`}
            >
              {item.type === "lucide" ? (
                <item.icon className={styles.icon} strokeWidth={2.2} />
              ) : (
                <img
                  src={item.icon}
                  alt={item.label}
                  className={styles.iconImg}
                />
              )}
            </div>

            <span className={styles.label}>{item.label}</span>
          </button>
        ))}
      </div>
    </div>
  );
}